import React from "react";
import "../src/App.css";
import Home from "./components/home/Home";
import ExperienceNew from "./components/experience/ExperienceNew";
import EducationNew from "./components/education/EducationNew";
import SkillsNew from "./components/skills/SkillsNew";
import Portfolio from "./components/portfolio/Portfolio";
import ContactNew from "./components/contact/ContactNew";
import ModeSelector from "./components/modeSelector/ModeSelector";

function App() {
  const uiComponent = (
    <React.Fragment>
      <main className="main">
        <Home />
        <ExperienceNew />
        <EducationNew />
        <SkillsNew />
        <Portfolio />
        <ContactNew />
      </main>
    </React.Fragment>
  );

  return <ModeSelector uiComponent={uiComponent} />;
}

export default App;
